import { useQuery, UseQueryOptions } from 'react-query';
import { BranchesService } from '../../services';
import { IBranchListItem } from '../../interfaces';

export const useAzerpostBranches = (query = {}, options?: UseQueryOptions<IBranchListItem[], Error, IBranchListItem[], ['azerpostbranches', object]>) => {
  return useQuery<IBranchListItem[], Error, IBranchListItem[], ['azerpostbranches', object]>(
    ['azerpostbranches', query],
    async ({ queryKey }) => {
      const [, params] = queryKey;
      const result = await BranchesService.getAzerpostBranches(params);
      if (result.status === 200) return result.data.data;
      throw new Error(result.data as string);
    },
    { staleTime: 5 * 60 * 1000, ...options },
  );
};
